export default __webpack_public_path__ + "static/media/logo.d2edd5bd.png";